/* eslint-disable @next/next/no-img-element */
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import P2 from '@base/P2/P2';
import { getImage } from '@utils/imageHelper';
import { dateWithTime } from '@utils/dates';

const Wrapper = styled.div`
  display: flex;
  align-items: ${({ isSubtitle }) => (isSubtitle ? 'normal' : 'center')};
`;

const InfoWrapper = styled.div`
  padding-left: 16px;
`;

const Title = styled(P2)`
  color: var(--color-text-primary);
  font-weight: 600;
  font-size: 14px;
`;

const Info = styled.span`
  font-size: 12px;
  line-height: 150%;
  color: var(--color-text-secondary);
  display: block;
`;

const Subtitle = styled(P2)`
  font-size: 14px;
  line-height: 150%;
  color: var(--color-text-secondary);
`;

const CardHeader = ({ message, created_at, img, subtitle }) => {
  return (
    <Wrapper isSubtitle={!!subtitle}>
      <img src={getImage(img)} height="48px" width="48px" alt="rescheduled" />
      <InfoWrapper>
        <Title>{message}</Title>
        {subtitle && <Subtitle lineClamp={1}>{subtitle}</Subtitle>}
        <Info>{dateWithTime(created_at)}</Info>
      </InfoWrapper>
    </Wrapper>
  );
};

export default CardHeader;

CardHeader.propTypes = {
  message: PropTypes.string.isRequired,
  created_at: PropTypes.string.isRequired,
  img: PropTypes.string.isRequired,
  subtitle: PropTypes.string
};

CardHeader.defaultProps = {
  subtitle: null
};
